import { capitalizeFirstLetter } from "@/lib/utils"
import { Radio } from "@material-tailwind/react"


const SubscriptionPlanCard = ({ product, selectedPlan, setSelectedPlan, setFormData, formData }) => {
    return (
        <div className={`flex items-center justify-between w-full rounded-lg ${formData.stripe_price_id === product?.id ? 'bg-[#F3FAEB] border border-primary' : ''}`}>
            <div className='flex items-center gap-2 px-1.5 py-2 rounded-md'>
                <Radio 
                    name="plan" 
                    label="" 
                    value={product?.id}
                    color="light-green"
                    checked={selectedPlan?.id === product?.id}
                    onChange={() => {
                        setSelectedPlan(product)
                        setFormData((prev) => ({
                            ...prev,
                            selectedPlanName: product?.interval,
                            stripe_price_id: product?.id
                        }))
                    }}
                    className='cursor-pointer checked:ring-2 checked:ring-[#6EAC36] h-4 w-4'
                />
                <div>
                    <h1 className='font-medium text-sm'>Culineer Professional - {capitalizeFirstLetter(product?.interval)}</h1>
                    <h6 className='font-normal text-sm text-gray-500'>{product?.interval.toLowerCase() === 'month' ? 'Renewal on every month' : 'Renewal on every year'}</h6>
                </div>
            </div>
            <div className='flex flex-col items-center rounded-md px-3'>
                <h6 className='font-medium text-sm'>${Intl.NumberFormat('en-US', {minimumFractionDigits: 2}).format(product?.unitAmount/100)}</h6>
                {product?.interval.toLowerCase().includes('year') && <span className='text-[13px] text-primary'>Save 20%</span>}
            </div>
        </div>
    )
}

export default SubscriptionPlanCard